import { toggleContentOverlay } from "./helper";

// Set elements to constants
const sidebar = document.querySelector('#sidebar');
const sidebarOpenBtn = document.querySelector('#sidebar-open');
const sidebarCloseBtn = document.querySelector('#sidebar-close');

if (sidebar && sidebarOpenBtn) {
    // Add event listener to sidebar open button to show sidebar
    sidebarOpenBtn.addEventListener('click', () => {
        document.body.classList.add("sidebar-container-toggled");
        document.body.classList.add("overflow-hidden");
        toggleContentOverlay(true);
    });

    // Add event listener to sidebar close button to hide sidebar
    sidebarCloseBtn?.addEventListener('click', () => {
        document.body.classList.remove("sidebar-container-toggled");
        document.body.classList.remove("overflow-hidden");
        toggleContentOverlay(false);
    });
}